import {
  FETCH_SUMMARY_STATUS_LOADING,
  FETCH_SUMMARY_STATUS_SUCCESS,
  FETCH_SUMMARY_STATUS_FAILED,
} from "../types";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const summaryStatusReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_SUMMARY_STATUS_LOADING:
      return { ...state, loading: true, error: null };
    case FETCH_SUMMARY_STATUS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_SUMMARY_STATUS_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default summaryStatusReducer;
